export default __webpack_public_path__ + "static/how-subs-work-29f527fbc50d2469cb83d8d36e15e2c9.png";